import { BlockType } from '../../types/index.js';
import { CollectionHeaderBlock as Component } from './Block.js';
export const RegisteredCollectionHeaderBlock = (_intl) => ({
    recommendedName: 'CollectionHeader',
    Component,
    config: {
        type: BlockType.Block,
        deprecated: true,
        defaultProps: {
            collectionId: '{{ collectionId }}',
        },
    },
});
//# sourceMappingURL=registered.js.map